import type {
  SetSeekMaxCommentLikedStatusMutation,
  SetSeekMaxThreadLikedStatusMutation,
} from 'src/generated/gql/graphql';

export interface LikeData {
  countLabel: string;
  isLiked: boolean;
}

export interface LikeDataInFeed {
  id: string;
  countLabel: string;
  isLiked: boolean;
}

export type ThreadLike = LikeData;
export type CommentLike = LikeData;

export const generateThreadLike = (
  mutation: SetSeekMaxThreadLikedStatusMutation | undefined | null,
): ThreadLike => {
  if (
    mutation?.setSeekMaxThreadLikedStatus.__typename ===
    'SeekMaxThreadLikedStatusSuccess'
  ) {
    const { liked, likeCount } = mutation.setSeekMaxThreadLikedStatus;
    return {
      countLabel: likeCount.label,
      isLiked: liked,
    };
  }
  return {
    countLabel: '0',
    isLiked: false,
  };
};

export const generateCommentLike = (
  mutation: SetSeekMaxCommentLikedStatusMutation | undefined | null,
): CommentLike => {
  if (
    mutation?.setSeekMaxCommentLikedStatus.__typename ===
    'SeekMaxCommentLikedStatusSuccess'
  ) {
    const { liked, likeCount } = mutation.setSeekMaxCommentLikedStatus;
    return {
      countLabel: likeCount.label,
      isLiked: liked,
    };
  }
  return {
    countLabel: '0',
    isLiked: false,
  };
};
